import React from "react";
import _ from "lodash";
import { Formik } from "formik";
import axios from "axios";
import moment from "moment";
import { Div, Text, Button, Modal, Input, Icon } from "atomize";

import { applyToJoinValidator } from "../validators";
import { addUtmInputValues, getUTMcookie } from "../utilities/helpers";

class CreatorsModal extends React.Component {
  formikProps;

  /**
   * on submit form
   */
  onSubmit = values => {
    const { onClose, isOpen } = this.props;

    // if (
    //   values.email.indexOf("@gmail") > -1 ||
    //   values.email.indexOf("@yahoo") > -1 ||
    //   values.email.indexOf("@hotmail") > -1
    // ) {
    //   this.formikProps.setSubmitting(false);
    //   this.formikProps.setStatus({
    //     errorMessage: "Please enter your work email address.",
    //   });

    //   return false;
    // }

    const utmArray = getUTMcookie();
    const inputs = addUtmInputValues(values, utmArray);

    axios
      .post("/api/apply-to-join", {
        ...inputs,
        date: moment().format("MMMM DD, YYYY"),
        time: moment().format("h:mm A"),
      })
      .then(() => {
        this.formikProps.setSubmitting(false);
        this.formikProps.resetForm();
        this.formikProps.setStatus({
          successMessage: "Submitted!",
          errorMessage: null,
        });

        window.location.href = "/thank-you/creator-application";

        onClose();
      })
      .catch(error => {
        this.formikProps.setSubmitting(false);
        this.formikProps.setStatus({
          successMessage: null,
          errorMessage: "Something went wrong",
        });
      });
  };

  render() {
    const { onClose, isOpen } = this.props;

    return (
      <Formik
        initialValues={{
          name: "",
          handle: "",
          worked_with: "",
          email: "",
        }}
        onSubmit={this.onSubmit}
        validationSchema={applyToJoinValidator}
      >
        {props => {
          const {
            values,
            touched,
            errors,
            status,
            setFieldValue,
            isSubmitting,
            handleChange,
            handleBlur,
            submitCount,
            handleSubmit,
          } = props;

          this.formikProps = props;

          return (
            <Modal
              isOpen={isOpen}
              onClose={onClose}
              rounded="md"
              //maxW="32rem"
              maxW={{ xs: "100vw", md: "36rem" }}
              align={{ xs: "flex-start", md: "center" }}
              m="0"
            >
              <Icon
                name="Cross"
                pos="absolute"
                top="1rem"
                right="1rem"
                size="24px"
                onClick={onClose}
                cursor="pointer"
              />
              <Div>
                <Div d="flex">
                  <Div
                    d="flex"
                    align="center"
                    w={{ xs: "100vw", lg: "100%" }}
                    textColor="black"
                  >
                    <Div
                      d="flex"
                      flexDir="column"
                      p={{ y: { xs: "4rem", md: "2rem", xl: "1rem" } }}
                      justify="space-evenly"
                      m="0 auto"
                    >
                      <Text
                        textSize={{
                          xs: "subheader2",
                          md: "title2",
                        }}
                        textWeight="700"
                        m={{ b: "1rem" }}
                        textAlign="center"
                      >
                        Request your invitation
                      </Text>
                      <Text
                        textSize="paragraph"
                        textAlign="center"
                        m={{ b: "2rem" }}
                      >
                        Give us some info below and we'll let you know if you're
                        accepted.
                      </Text>
                      <Div
                        minW={{ md: "20rem" }}
                        maxW={{ md: "22rem" }}
                        m="auto"
                      >
                        <Div m={{ b: "1.4rem" }}>
                          <Text
                            textColor="danger800"
                            m={{ t: "0.5rem", b: "1rem" }}
                          >
                            {_.get(status, "errorMessage")}
                          </Text>
                          <Text
                            textSize="body"
                            style={{ lineHeight: "1.2rem" }}
                            textWeight="700"
                            m={{ b: "0.4rem" }}
                          >
                            Full Name
                          </Text>
                          <Input
                            bg="gray200"
                            hove
                            bg="gray200"
                            hoverBg="gray200"
                            rBg="gray200"
                            border="0px"
                            placeholder="First Name"
                            h="3.1rem"
                            textSize="body"
                            fontFamily="secondary"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="name"
                            value={values.name}
                            p={{ l: "1rem", t: "1rem", b: "1rem" }}
                          />
                          <p style={{ color: "red" }}>
                            {touched.name && errors.name}
                          </p>
                        </Div>
                        <Div m={{ b: "1.4rem" }}>
                          <Text
                            textSize="body"
                            style={{ lineHeight: "1.2rem" }}
                            textWeight="700"
                            m={{ b: "0.4rem" }}
                          >
                            Instagram Handle
                          </Text>
                          <Input
                            bg="gray200"
                            hoverBg="gray200"
                            border="0px"
                            placeholder="@username"
                            h="3.1rem"
                            textSize="body"
                            fontFamily="secondary"
                            p={{ l: "1rem", t: "1rem", b: "1rem" }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="handle"
                            value={values.handle}
                          />
                          <p style={{ color: "red" }}>
                            {touched.handle && errors.handle}
                          </p>
                        </Div>
                        <Div m={{ b: "1.4rem" }}>
                          <Text
                            textSize="body"
                            style={{ lineHeight: "1.2rem" }}
                            textWeight="700"
                            m={{ b: "0.4rem" }}
                          >
                            Email Address
                          </Text>
                          <Input
                            bg="gray200"
                            hoverBg="gray200"
                            border="0px"
                            placeholder="yourname@email.com"
                            h="3.1rem"
                            textSize="body"
                            fontFamily="secondary"
                            p={{ l: "1rem", t: "1rem", b: "1rem" }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="email"
                            value={values.email}
                          />
                          <p style={{ color: "red" }}>
                            {touched.email && errors.email}
                          </p>
                        </Div>
                        <Div>
                          <Text
                            textSize="body"
                            style={{ lineHeight: "1.2rem" }}
                            textWeight="700"
                            m={{ b: "0.4rem" }}
                          >
                            Last 3-5 Brands You've Worked with
                          </Text>
                          <Input
                            bg="gray200"
                            hoverBg="gray200"
                            border="0px"
                            placeholder="ex. Adidas, MVMT, Fossil"
                            h="3.1rem"
                            textSize="body"
                            fontFamily="secondary"
                            p={{ l: "1rem", t: "1rem", b: "1rem" }}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="worked_with"
                            value={values.worked_with}
                          />
                          <p style={{ color: "red" }}>
                            {touched.worked_with && errors.worked_with}
                          </p>
                        </Div>

                        <Div m={{ t: "1.5rem", b: "3rem" }}>
                          <Button
                            textSize="subheader2"
                            textWeight="600"
                            bg="primary"
                            textColor="black"
                            textAlign="center"
                            rounded="md"
                            w="100%"
                            h="auto"
                            onClick={handleSubmit}
                            textSize="subheader1"
                            p={{ t: "1rem", b: "1rem" }}
                          >
                            Send
                          </Button>
                        </Div>

                        <Text textSize="13px" style={{ lineHeight: "20px" }}>
                          By applying to Trend, you agree to receiving
                          ocassional email newsletters and/or promotional
                          materials from Trend.
                        </Text>
                      </Div>
                    </Div>
                  </Div>
                </Div>
              </Div>
            </Modal>
          );
        }}
      </Formik>
    );
  }
}

export default CreatorsModal;
